import AlectsActionTypes from './types';
import { action } from 'typesafe-actions';
import { AppAlert, AlertOptions } from 'types';
import { NotificationKind } from 'carbon-components-react';
import { v4 as UUIDV4 } from 'uuid';

export const addAlert = (
  group: string,
  kind: NotificationKind = 'info',
  message: string = '',
  details: any = '',
  options: AlertOptions = {}
) => {
  const {
    id,
    withClose = true,
    notificationProps,
    type,
    timeout,
    stayForever
  } = options;
  const alert: AppAlert = {
    group,
    kind,
    message,
    details,
    withClose,
    id: id || UUIDV4(),
    notificationProps,
    type,
    timeout,
    stayForever
  };
  return action(AlectsActionTypes.ADD_ALERT, alert);
};

export const removeAlert = (id: string) =>
  action(AlectsActionTypes.REMOVE_ALERT, id);

export const removeAlertByGroup = (group: string) =>
  action(AlectsActionTypes.REMOVE_ALERT_BY_GROUP, group);

export const removeAllAlerts = () =>
  action(AlectsActionTypes.REMOVE_ALL_ALERTS);
